import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
export const getDownloadCode = (params) => {
  return request({
    url: `${baseUrl}/joins-product/v1/app_product/downloadMiniProgramCodeImageV2`,
    method: "POST",
    responseType: 'blob',
    data: params,
  });
};
// 获取代理商Id
export const getRootDepartmentId = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/getRootDepartmentId`,
    method: "GET",
  });
};
export const findWaterProject = (params) => {
  params = parseParam(params);
  params = params + "&type=ENGINEERING";
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration?` + params,
    method: "GET",
  });
};
export const getMerchantOrder = (params) => {
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/customs_declaration?id=` +
      params,
    method: "GET",
  });
};
export const editMerchantOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration`,
    method: "PUT",
    data: data,
  });
};
export const downloadExcelCustomsDeclaration = (params) => {
  params = parseParam(params);
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelCustomsDeclaration?` +
      params,
    method: "GET",
    responseType: "blob",
  });
};
export const findWaterProjectAll = () => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/choose/agent`,
    method: "GET",
  });
};

export const addWaterProject = (data) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent`,
    method: "POST",
    data: data,
  });
};

export const editWaterProject = (data) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent`,
    method: "PUT",
    data: data,
  });
};

export const delWaterProject = (ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent/${temp}`,
    method: "DELETE",
  });
};
export const chooseSecondWaterProject = (id) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
    method: "GET",
  });
};
export const handleRebates = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/audit/${data.id}`,
    method: "PUT",
    data,
  });
};
// 新增提货单
export const addDeliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "POST",
    data: data,
  });
};
// 搜索监理
export const findBindEngineer = (params) => {
  params = parseParam(params)
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineer?` + params,
      method: 'GET'
  })
}
// 指派监理
export const addBindEngineer = (params) => {
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineering_order`,
      method: 'POST',
      data: params
  })
}
// 获取监理列表
export const findEngineer = (params) => {
  params = parseParam(params)
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineering_order?` + params,
      method: 'GET'
  })
}

// 获取合同内容（根据报单ID）
// 备注：后端需提供接口返回小程序提交的合同内容(JSON)，包含 meta/parties/pricing/settlement/materials/terms/dates/signatures 等字段
export const getContractByDeclarationId = (declarationId) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/app_customs_declaration/warranty?id=${declarationId}`,
    method: 'GET',
  });
};